import React from 'react';
import { ArcMenuItem, ArcOutlinedSelect, ArcStack, ArcText } from '@src/core/ui';
import { CameraControlsProps } from '../../types';
import { CAMERA_ACTION_OPTIONS, CAMERA_CONTROL_LABELS, CameraActionEnum, CameraControlKey } from '../../config/controller-constants';

const CAMERA_CONTROL_ORDER: CameraControlKey[] = [
  'dPadUp',
  'dPadDown',
  'dPadLeft',
  'dPadRight',
  'l2',
  'r2',
  'circle',
  'cross',
  'square',
  'triangle',
  'l1',
  'r1',
];

const CameraControls: React.FC<CameraControlsProps> = ({ cameraControls, onCameraControlChange }) => {
  return (
    <ArcStack spacing={3} flex={1}>
      <ArcText.h3>Camera Controls</ArcText.h3>

      <ArcStack spacing={2}>
        {CAMERA_CONTROL_ORDER.map((key) => (
          <ArcStack key={key} spacing={1} direction='row' alignItems='center' justifyContent='space-between'>
            <ArcText.h5>{CAMERA_CONTROL_LABELS[key]}</ArcText.h5>
            <ArcOutlinedSelect
              sx={{ width: 250 }}
              value={cameraControls[key]}
              onChange={(e) => {
                const value = e.target.value as CameraActionEnum;
                onCameraControlChange(key, value);
              }}
            >
              {CAMERA_ACTION_OPTIONS.map(({ value, name }) => (
                <ArcMenuItem key={value} value={value}>
                  {name}
                </ArcMenuItem>
              ))}
            </ArcOutlinedSelect>
          </ArcStack>
        ))}
      </ArcStack>
    </ArcStack>
  );
};

export default CameraControls;
